import gql from 'graphql-tag';

export const getCTPPreferenceQL = gql`
  query GetCTPPreference(
    $locale: Locale!
    $onlyProductionOption: Boolean!
    $zone: Zone!
  ) {
    viewer {
      notificationCTPPreferenceGroups(
        zone: $zone
        onlyProductionOption: $onlyProductionOption
      ) {
        category {
          description(locale: $locale)
          id
          label(locale: $locale, zone: $zone)
        }
        preferences {
          product {
            description(locale: $locale, zone: $zone)
            id
            label(locale: $locale)
            action {
              label(locale: $locale, zone: $zone)
              path
            }
          }
          subscriptions {
            channel {
              label(locale: $locale)
              id
            }
            frequency {
              value
              options {
                id
                label(locale: $locale)
                description(locale: $locale)
              }
            }
            id
            subscribed
            token
          }
        }
      }
    }
  }
`;

export const updateCTPPreferenceQL = gql`
  mutation updateNotificationCtpPreferences(
    $input: UpdateNotificationCtpPreferenceInput!
    $locale: Locale!
  ) {
    updateNotificationCtpPreferences(input: $input) {
      ... on UpdateNotificationCtpPreferencesSuccess {
        success {
          preferences {
            product {
              id
            }
            subscriptions {
              channel {
                label(locale: $locale)
                id
              }
              frequency {
                value
                options {
                  id
                  label(locale: $locale)
                  description(locale: $locale)
                }
              }
              id
              subscribed
              token
            }
          }
        }
      }
    }
  }
`;

export const updateCTPSubscriptionQL = gql`
  mutation updateNotificationCtpSubscriptionWithToken(
    $input: NotificationCtpSubscriptionWithTokenInput!
    $locale: Locale!
  ) {
    updateNotificationCtpSubscriptionWithToken(input: $input) {
      ... on UpdateNotificationCtpSubscriptionWithTokenSuccess {
        product {
          id
          label(locale: $locale)
        }
        subscriptionChannel {
          id
        }
        subscribed
      }
      ... on UpdateNotificationCtpPreferenceFailure {
        error {
          errorCode
          message(locale: $locale)
        }
      }
    }
  }
`;
